import React from 'react';
import { useQuery } from '../hooks/useQuery';
import Moment from 'moment';
import NotaItem from './NotaItem';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

export default function RowNotaFiscalDetails({ nota, index, cnpj, expanded }) {
  const { obterHistoricoStatusNotaFiscal, atualizarNota } = useQuery();

  const [statuses, setStatuses] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    if (expanded) {
      obterHistoricoStatus();
    }
  }, [expanded]);

  const obterHistoricoStatus = (e) => {
    setIsLoading(true);
    obterHistoricoStatusNotaFiscal(nota.id)
      .then(({ data }) => {
        let find = false;
        let dataModify = [];
        data.forEach((element, index) => {
          if (element.desc_movto == 'AGUARDANDO PAGAMENTO') {
            if (!find) {
              dataModify.push(element);
            }
            find = true;
          } else {
            dataModify.push(element);
          }
        });
        setStatuses(dataModify);
        if (data && data.length > 0) {
          console.log('open', data);
          nota.situacao_nf =
            nota.situacao_nf == 'CANCELADO' ? 'CANCELADO' : data[0].desc_movto;
          nota.obeservacao_nf = data[0].obs_movto;
          nota.numero_processo_fluig = data[0].processo_fluig;
          nota.choosed_state = data[0].cod_ativ;
          nota.data_emissao_nf = Moment(
            nota.data_emissao_nf.split(' ')[0],
          ).format('YYYY-MM-DD');
          if (nota.data_competencia) {
            nota.data_competencia = Moment(
              nota.data_competencia.split(' ')[0],
            ).format('YYYY-MM-DD');
          }
          if (nota.data_emissao_rps) {
            nota.data_emissao_rps = Moment(
              nota.data_emissao_rps.split(' ')[0],
            ).format('YYYY-MM-DD');
          }
          nota.cnpj_contexto = cnpj;
          atualizarNota(nota.id, nota);
        }

        setIsLoading(false);
      })
      .catch((e) => setIsLoading(false));
  };

  return (
    <tr>
      <td colSpan={7} align="center">
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress />
          </Box>
        ) : (
          <NotaItem nota={nota} statuses={statuses} />
        )}
      </td>
    </tr>
  );
}
